module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAA7ElEQVQ4T52SvUoDQRRGzyfJKyghbyBBsNTGIomioKWgQt7ClCLYhmAnsdQH86dSC0UU3e6TCxPZ3ewK7nRnmDPzzb1XNFxq6PEr2t4AToFjSVmZyw/kxTZwC6wAB0CWeDlY0mdeLkS1vQRcAz1gD3hPvBos6W0uL/zRduxNgT6wDTwDl8BWsKSXkGuLY/scOAGGku5tXwCHiR//Es+AUTp4l7toIOmhUrQ9AXaS9GQ7og8SR/Ri1FScK2Ad2AWiGDNgLVjS60JxbLeAG6AL7ANfqR2dYEkfle2wvQmMgSNJ32WuHYD/jl7jWf0BoyBVD1ewOG8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhengwu/sh_btn_more.png
// module id = 5k90
// module chunks = 1